export const getConsultations = (state,consultations)=>{
    state.consultations = consultations;
}
export const getAppelOffre = (state,appels_offre)=>{
    state.appels_offre = appels_offre;
}

